// import { Input } from 'components/input';
import React from 'react';
import CheckBox from '../Experiment/ImagingSchedule/CheckBox';

export default function CheckboxCustom({
  id,
  onClick,
  label,
  checked,
  value,
  isDisable = false,
  inputStyle = undefined,
  labelClass = '',
}) {
  return (
    <div
      id="controls-checkboxcustom-wrapper"
      data-testid="controls-checkboxcustom-wrapper"
      key={id}
      className={`flex flex-y-center self-start`}
      style={inputStyle}
    >
      <CheckBox
        isChecked={checked}
        onChange={onClick}
        disabled={isDisable}
        className="h-8"
      />
      <label
        id={`controls-checkboxcustom-label-${label}`}
        data-testid={`controls-checkboxcustom-label-${label}`}
        className={`input-label ${labelClass}`}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}
